import React from 'react';
import { SearchX, MapPinOff, MessageSquareOff, UserX, Users } from 'lucide-react';
export function Problem() {
  return <section className="py-20 px-6 lg:px-8 bg-white" data-id="element-397">
      <div className="max-w-5xl mx-auto" data-id="element-398">
        <div className="grid md:grid-cols-2 gap-16 items-start" data-id="element-399">
          {/* Section 2: El Problema */}
          <div data-id="element-400">
            <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-6" data-id="element-401">
              El Problema
            </h2>
            <p className="text-lg text-gray-700 mb-6 font-medium" data-id="element-402">
              Muchas veces los vecinos quieren participar, pero no saben por
              dónde empezar.
            </p>

            <ul className="space-y-4 mb-8 text-gray-600" data-id="element-403">
              {['No saben cuándo será la próxima reunión.', 'No encuentran la agenda.', 'No saben a quién contactar.', 'No tienen claro cómo reportar un problema.', 'No saben si pueden asistir.', 'No saben si su voz realmente cuenta.'].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-404">
                  <SearchX className="w-6 h-6 text-sky shrink-0 mt-0.5" data-id="element-405" />
                  <span data-id="element-406">{text}</span>
                </li>)}
            </ul>

            <div className="bg-sylmar-light p-6 rounded-xl border border-sylmar/20" data-id="element-407">
              <p className="text-charcoal font-medium italic" data-id="element-408">
                "Y cuando la información está dispersa, la participación baja.
                Una comunidad puede tener vecinos comprometidos, familias
                preocupadas, negocios locales interesados y líderes con buenas
                ideas… pero si no existe un camino claro para tomar acción,
                muchas personas se quedan fuera."
              </p>
            </div>
          </div>

          {/* Section 3: Agitación del Problema */}
          <div data-id="element-409">
            <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-6" data-id="element-410">
              Las Consecuencias
            </h2>
            <p className="text-lg text-gray-700 mb-6 font-medium" data-id="element-411">
              Cuando los vecinos no tienen acceso fácil a la información, los
              problemas se sienten más grandes.
            </p>

            <ul className="space-y-4 mb-8 text-gray-600" data-id="element-412">
              {[{
              icon: MapPinOff,
              text: 'Una calle peligrosa sigue sin reportarse.'
            }, {
              icon: SearchX,
              text: 'Un problema de limpieza tarda más en atenderse.'
            }, {
              icon: Users,
              text: 'Una familia no encuentra recursos disponibles.'
            }, {
              icon: UserX,
              text: 'Un adulto mayor no sabe dónde pedir ayuda.'
            }, {
              icon: MessageSquareOff,
              text: 'Un joven no encuentra oportunidades para participar.'
            }, {
              icon: SearchX,
              text: 'Un negocio local no sabe cómo conectar con la comunidad.'
            }].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-413">
                  <item.icon className="w-6 h-6 text-sky-dark shrink-0 mt-0.5" data-id="element-414" />
                  <span data-id="element-415">{item.text}</span>
                </li>)}
            </ul>

            <div className="space-y-4" data-id="element-416">
              <p className="text-gray-700" data-id="element-417">
                Y poco a poco, muchas personas empiezan a sentir que participar
                es complicado.
              </p>
              <p className="text-xl font-bold text-charcoal" data-id="element-418">
                Pero no debería ser así.
              </p>
              <p className="text-gray-700" data-id="element-419">
                Participar en tu comunidad debe ser simple, claro y accesible.
                Debes poder saber qué está pasando, cuándo reunirte, cómo enviar
                un comentario, cómo reportar un problema y cómo mantenerte
                informado sin tener que buscar en varios lugares.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}